import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import './Login.css';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mode, setMode] = useState('login'); // 'login' | 'forgot' | 'sent'
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const message = location.state?.message;

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(phone, password);
      const from = location.state?.from || '/';
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid phone number or password');
    } finally {
      setLoading(false);
    }
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setMode('sent');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-card__header">
          <div className="login-logo">🍴</div>
          <h1>Recipe<strong>Sense</strong></h1>
          <p>Your personal recipe collection</p>
        </div>

        {message && (
          <div className="login-message">{message}</div>
        )}

        {mode === 'login' && (
          <form onSubmit={handleLogin} className="login-form">
            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                id="phone"
                type="tel"
                value={phone}
                onChange={e => setPhone(e.target.value)}
                placeholder="602-716-1121"
                required
                autoComplete="tel"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                autoComplete="current-password"
              />
            </div>
            {error && <div className="login-error">{error}</div>}
            <button type="submit" className="btn btn-primary login-btn" disabled={loading}>
              {loading ? <span className="spinner" /> : 'Sign In'}
            </button>
            <button
              type="button"
              className="login-forgot"
              onClick={() => { setMode('forgot'); setError(''); }}
            >
              Forgot password?
            </button>
          </form>
        )}

        {mode === 'forgot' && (
          <form onSubmit={handleForgot} className="login-form">
            <p className="login-sub">Enter your email address and we'll send you a reset link.</p>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                autoComplete="email"
              />
            </div>
            {error && <div className="login-error">{error}</div>}
            <button type="submit" className="btn btn-primary login-btn" disabled={loading}>
              {loading ? <span className="spinner" /> : 'Send Reset Link'}
            </button>
            <button
              type="button"
              className="login-forgot"
              onClick={() => { setMode('login'); setError(''); }}
            >
              ← Back to sign in
            </button>
          </form>
        )}

        {mode === 'sent' && (
          <div className="login-sent">
            <div className="login-sent__icon">📧</div>
            <h3>Check your email</h3>
            <p>We sent a password reset link to <strong>{email}</strong></p>
            <button
              className="btn btn-outline"
              onClick={() => { setMode('login'); setEmail(''); }}
            >
              Back to Sign In
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
